document.addEventListener('DOMContentLoaded', () => {
  const nameInput = document.querySelector('input[name="customerName"]');

  if (nameInput) {
    nameInput.placeholder = 'Full Name';

    // update only its label (same container)
    const label = nameInput.closest('#offerNameInputInput')?.querySelector('label');
    if (label) label.textContent = 'Full Name';
  }
});